import { InheritedLayoutImageTransform } from 'utils/level-layout-image';
import {
  LayoutImagePixelSize,
  LayoutImageStartPosition,
  StackedLayoutImageTransformInput
} from 'utils/stacked-layout-image-transform-types';

export function layoutImagePixelArea(dims: LayoutImagePixelSize): number {
  return dims.naturalWidth * dims.naturalHeight;
}

export function pickLargestLayoutImage<
  T extends { dims: LayoutImagePixelSize; hasPose?: boolean }
>(images: T[]): T | null {
  if (images.length === 0) {
    return null;
  }

  return images.reduce((largest, image) => {
    const imageArea = layoutImagePixelArea(image.dims);
    const largestArea = layoutImagePixelArea(largest.dims);
    if (imageArea > largestArea) {
      return image;
    }
    if (imageArea < largestArea) {
      return largest;
    }
    if (image.hasPose && !largest.hasPose) {
      return image;
    }
    return largest;
  });
}

export function computeCenteredOnLargestStartPosition(
  dims: LayoutImagePixelSize,
  largestDims: LayoutImagePixelSize,
  largestStart: LayoutImageStartPosition
): LayoutImageStartPosition {
  return {
    startPositionX: Math.round(
      largestStart.startPositionX +
        (largestDims.naturalWidth - dims.naturalWidth) / 2
    ),
    startPositionY: Math.round(
      largestStart.startPositionY +
        (largestDims.naturalHeight - dims.naturalHeight) / 2
    )
  };
}

export function computeStackedLayoutImageTransform({
  isLargest,
  dims,
  largestDims,
  largestStart,
  scale,
  rotation
}: StackedLayoutImageTransformInput): InheritedLayoutImageTransform {
  if (isLargest) {
    return {
      scale,
      rotation,
      startPositionX: largestStart.startPositionX,
      startPositionY: largestStart.startPositionY
    };
  }

  const start = computeCenteredOnLargestStartPosition(
    dims,
    largestDims,
    largestStart
  );

  return {
    scale,
    rotation,
    startPositionX: start.startPositionX,
    startPositionY: start.startPositionY
  };
}
